import React, { useState } from 'react';
import {
    Typography,
    Box,
    Grid,
    Paper,
    Divider,
    Button,
    Avatar,
    alpha
} from '@mui/material';
import {
    Mail,
    Send,
    Calendar,
    Briefcase
} from 'lucide-react';

// Mock Data
const sentMailsData = [
    {
        id: 1,
        to: 'John Doe',
        role: 'Software Engineer',
        company: 'Tech Solutions',
        email: 'john.doe@example.com',
        subject: 'Software Engineer Position',
        date: '2024-03-20',
        postedDate: '2024-03-15',
        campaign: 'Spring Tech Recruitment',
        avatarColor: '#FF6B6B',
        content: `Dear John Doe,\n\nWe are excited to reach out regarding the Software Engineer position...`
    },
    {
        id: 2,
        to: 'Jane Smith',
        role: 'Product Manager',
        company: 'Innovate Corp',
        email: 'jane.smith@Innovatecorp.com',
        subject: 'Product Manager Role',
        date: '2024-03-22',
        postedDate: '2024-03-18',
        campaign: 'Leadership Hiring',
        avatarColor: '#4ECDC4',
        content: `Dear Jane Smith,\n\nWe are thoroughly impressed with your distinguished product management expertise...`
    },
     {
        id: 3,
        to: 'Haris Jones',
        role: 'Front End Developer',
        company: 'Tek sharp',
        email: 'jane.smith@teksharap.com',
        subject: 'Product Manager Role',
        date: '2024-03-22',
        postedDate: '2024-03-18',
        campaign: 'Leadership Hiring',
        avatarColor: '#4966D2',
        content: `Dear Jane Smith,\n\nWe are thoroughly impressed with your distinguished product management expertise...`
    },
    {
        id: 4,
        to: 'Jacob Bethol',
        role: 'Full stack Developer',
        company: 'Synchrozian',
        email: 'jane.smith@Synchrozian.com',
        subject: 'Product Manager Role',
        date: '2024-03-22',
        postedDate: '2024-03-18',
        campaign: 'Leadership Hiring',
        avatarColor: '#1976D2',
        content: `Dear Jane Smith,\n\nWe are thoroughly impressed with your distinguished product management expertise...`
    },
    {
        id: 5,
        to: 'Michel Clarke',
        role: 'Full stack Developer',
        company: 'amazon',
        email: 'jane.smith@amzon.com',
        subject: 'Product Manager Role',
        date: '2024-03-22',
        postedDate: '2024-03-18',
        campaign: 'Leadership Hiring',
        avatarColor: '#1845DW',
        content: `Dear Jane Smith,\n\nWe are thoroughly impressed with your distinguished product management expertise...`
    },
    {
        id: 6,
        to: 'Will Jacks',
        role: 'Data engineer ',
        company: 'data',
        email: 'jane.smith@amzon.com',
        subject: 'Product Manager Role',
        date: '2024-03-22',
        postedDate: '2024-03-18',
        campaign: 'Leadership Hiring',
        avatarColor: '#74E85D',
        content: `Dear Jane Smith,\n\nWe are thoroughly impressed with your distinguished product management expertise...`
    }
];

const RecruiterMailView = () => {
    const [selectedMail, setSelectedMail] = useState(sentMailsData[0]);

    const handleResendMail = (mail) => {
        alert(`Resending mail to ${mail.email}`);
    };

    const getInitials = (name) => {
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    return (
        <Box sx={{ height: '100vh', backgroundColor: '#f0f2f5', padding: 1 }}>
            <Grid container spacing={2} sx={{ height: '100%' }}>

                {/* Left Sidebar */}
                <Grid item xs={12} md={3}>
                    <Paper
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            borderRight: '1px solid #e0e0e0',
                            boxShadow: '2px 0 10px rgba(0,0,0,0.05)'
                        }}
                    >
                        {/* Sidebar Header */}
                        <Box sx={{ padding: 2, backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 ,fontSize:"15px"}}>
                                <Mail size={24} /> Sent Mails ({sentMailsData.length})
                            </Typography>
                        </Box>

                        {/* Mail List */}
                        <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
                            {sentMailsData.map((mail) => (
                                <Box
                                    key={mail.id}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: "6px 3px 6px 11px",
                                        borderBottom: '1px solid #e0e0e0',
                                        backgroundColor: selectedMail?.id === mail.id
                                            ? alpha(mail.avatarColor, 0.1)
                                            : 'white',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s',
                                        '&:hover': { backgroundColor: alpha(mail.avatarColor, 0.05) }
                                    }}
                                    onClick={() => setSelectedMail(mail)}
                                >
                                    <Avatar
                                        sx={{ width: 40, height: 40, marginRight: 2, backgroundColor: mail.avatarColor,fontSize:'15px' }}
                                    >
                                        {getInitials(mail.to)}
                                    </Avatar>
                                    <Box sx={{ }}>
                                        <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '0.85rem' }}>
                                            {mail.role}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.75rem' }}>
                                            {mail.company}
                                        </Typography><br/>
                                        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
                                            Posted: {mail.postedDate}
                                        </Typography>
                                    </Box>

                                </Box>
                            ))}
                        </Box>
                    </Paper>
                </Grid>

                {/* Right Side: Mail Details */}
                <Grid item xs={12} md={9}>
                    {selectedMail && (
                        <Paper sx={{ height: '100%', padding: 3, display: 'flex', flexDirection: 'column' }}>

                            {/* Mail Header */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Avatar sx={{ width: 56, height: 56, backgroundColor: selectedMail.avatarColor }}>
                                        {getInitials(selectedMail.to)}
                                    </Avatar>
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 0.5 }}>
                                            {selectedMail.subject}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            To: {selectedMail.email}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Send size={20} />}
                                    onClick={() => handleResendMail(selectedMail)}
                                    sx={{ textTransform: 'none' }}
                                >
                                    Resend Mail
                                </Button>
                            </Box>

                            <Divider sx={{ marginY: 2 }} />

                            {/* Mail Metadata */}
                            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                                <Grid item xs={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Calendar size={20} />
                                        <Typography variant="body1">
                                            <strong>Date:</strong> {selectedMail.date}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Briefcase size={20} />
                                        <Typography variant="body1">
                                            <strong>Campaign:</strong> {selectedMail.campaign}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Mail Content */}
                            <Paper variant="outlined" sx={{ padding: 2, backgroundColor: 'white', flexGrow: 1 }}>
                                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', color: '#333' }}>
                                    {selectedMail.content}
                                </Typography>
                            </Paper>
                        </Paper>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default RecruiterMailView;
